module.exports = __webpack_public_path__ + "static/media/logistik.671ae620.jpg";